import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { HowToWatchPanel } from '../../styles';

export const PanelBroadcastWrapper = styled(HowToWatchPanel)`
    max-width: 326px;
    min-width: 290px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: 548px;
        min-width: 516px;
    }
`;

export const BroadcastsList = styled.div`
    ${BaseStyle.Mixins.gaps.small};
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const PanelHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle3};
    align-self: center;
    padding: 4px 0;
`;
